export const state = {
  nameWindow4: '',
  widthWindow4: null,
  heightWindow4: null,
  windowTypeSelected4: '',
  costStep1Window4: null,
  addWindow5: false
}

export const getters = {

}

export const mutations = {
  updateNameWindow4 (state, nameWindow4) {
    state.nameWindow4 = nameWindow4
  },
  updateWidthWindow4 (state, widthWindow4) {
    state.widthWindow4 = widthWindow4
  },
  updateHeightWindow4 (state, heightWindow4) {
    state.heightWindow4 = heightWindow4
  },
  windowTypeSelected4 (state, windowTypeSelected4) {
    state.windowTypeSelected4 = windowTypeSelected4
  },
  addWindow5Computed (state, addWindow5) {
    state.addWindow5 = !addWindow5
  },
  removeWindow5Computed (state) {
    state.addWindow5 = false
  },
  clearWindow4Params (state) {
    state.nameWindow4 = ''
    state.widthWindow4 = null
    state.heightWindow4 = null
    state.windowTypeSelected4 = ''
  },
  calcCostWindow4 (state) {
    if (state.widthWindow4 >= 2500 && state.windowTypeSelected4 === 'Эркерное окно') {
      state.costStep1Window4 = 3915 + (3915 * 0.35)
    } else if (state.widthWindow4 <= 2500 && state.windowTypeSelected4 === 'Эркерное окно') {
      state.costStep1Window4 = 2900 + (2900 * 0.35)
    } else if (state.widthWindow4 >= 2500) {
      state.costStep1Window4 = 2900 + (2900 * 0.35)
    } else {
      state.costStep1Window4 = 2900
    }
  }
}

export const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
